import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { string, func, bool } from 'prop-types';
import { Link, Box } from '../../atoms';
import { Label } from './delivery-guarantee.styles';

const ContentBox = _ref => {
  let {
    isMagaluCompany,
    onLinkClick
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["isMagaluCompany", "onLinkClick"]);

  const handleDetailsClick = () => {
    return onLinkClick == null ? void 0 : onLinkClick();
  };

  return isMagaluCompany ? /*#__PURE__*/React.createElement(Box, props, /*#__PURE__*/React.createElement(Label, {
    "data-testid": "guaranteelabel"
  }, "Empresa do", ' ', /*#__PURE__*/React.createElement(Link, {
    underline: true,
    display: "inline",
    color: "text.scratched",
    onClick: handleDetailsClick
  }, "Grupo Magalu"), ' ', "que garante sua compra do pedido \xE0 entrega.")) : /*#__PURE__*/React.createElement(Box, props, /*#__PURE__*/React.createElement(Label, {
    "data-testid": "guaranteelabel"
  }, "O Magalu garante a sua compra, do pedido \xE0 entrega.", ' ', /*#__PURE__*/React.createElement(Link, {
    underline: true,
    display: "inline",
    color: "text.scratched",
    "data-testid": "learn-more",
    onClick: handleDetailsClick
  }, "Saiba mais")));
};

process.env.NODE_ENV !== "production" ? ContentBox.propTypes = {
  id: string,
  delivery: string,
  isMagaluCompany: bool,
  onLinkClick: func
} : void 0;
ContentBox.defaultProps = {
  id: 'magazineluiza',
  delivery: 'magazineluiza',
  isMagaluCompany: false
};
export default ContentBox;